import { Box, Checkbox, Tooltip, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Info } from '@mui/icons-material';
import { useRecoilState } from 'recoil';
import { enableExportMonacoDirFileState } from '~/state/atoms/viewerAtoms';

const MonacoExportCheckbox = () => {
    const [enableExportMonacoDirFile, setEnableExportMonacoDirFile] =
        useRecoilState(enableExportMonacoDirFileState);
    return (
        <Box display="flex" alignItems="center" flexWrap="nowrap" gap={0.25}>
            <Checkbox
                size="small"
                color="primary"
                checked={enableExportMonacoDirFile}
                onChange={() =>
                    setEnableExportMonacoDirFile(!enableExportMonacoDirFile)
                }
            />
            <Typography variant="body2" mr={1}>
                <FormattedMessage id="exportMonacoDirFile" />
            </Typography>
            <Tooltip
                title={<FormattedMessage id="exportMonacoDirFileDescription" />}
            >
                <Info fontSize="small" />
            </Tooltip>
        </Box>
    );
};

export default MonacoExportCheckbox;
